export default {
  loginStatus: false,
  userInfo: {
    privileges: [],
  },
  mchDetail: {},

  menuList: [],
  register_key: null,
  downList: [],
  browser: {}
};
